import { formatDecimal, formatNumber, formatNumberCutZero, formatPercent } from '@/utils/filters';

export enum NumberInputEnum {
  number_cut_zero = 'number_cut_zero',
  integer = 'integer',
  currency = 'currency',
  percent = 'percent',
  decimal = 'decimal',
}

export const numberFormatter = {
  [NumberInputEnum.number_cut_zero]: (value) => formatNumberCutZero(value),
  [NumberInputEnum.integer]: (value) => formatNumber(value),
  [NumberInputEnum.decimal]: (value) => formatDecimal(value),
  [NumberInputEnum.percent]: (value) => formatPercent(value),
  [NumberInputEnum.currency]: (value) => formatDecimal(value),
}
